import axios from "axios";

/**
 *
 * @param {string} url
 */
export const isValidUrl = (urlString) => {
  let url;
  try {
    url = new window.URL(urlString);
  } catch (_) {
    return false;
  }
  return (
    (url.protocol === "http:" && urlString?.startsWith("http://")) ||
    (url.protocol === "https:" && urlString?.startsWith("https://"))
  );
};

/**
 *
 * @param {string} url
 */
export const isUrlLive = async (url) => {
  if (!isValidUrl(url)) return false;

  if (url.includes("localhost")) return true;

  // Mocking the response for localhost
  return true;
  // TODO: implement Logic to check URL is live or not
  const abortController = new AbortController();
  const timeout = setTimeout(() => {
    abortController.abort();
  }, 3000);

  try {
    const response = await axios.get(url, {
      signal: abortController.signal,
    });
    clearTimeout(timeout);
    return response.status === 200;
  } catch (error) {
    return false;
  }
};
